'use strict';

bbw.directive.bbwContentEditable = ['$timeout', 'bbw.SmileySvc', '$rootScope', function($timeout, smileySvc, $rootScope) {
    var voidNodeTags = ['AREA', 'BASE', 'BR', 'COL', 'EMBED', 'HR', 'IMG', 'INPUT', 'KEYGEN', 'LINK', 'MENUITEM', 'META', 'PARAM', 'SOURCE', 'TRACK', 'WBR', 'BASEFONT', 'BGSOUND', 'FRAME', 'ISINDEX'];

    function canContainText(node) {
        if (node.nodeType == 1) {
            return voidNodeTags.indexOf(node.nodeName) < 0;
        } else {
            return false;
        }
    }

    function getLastChildElement(el) {
        var lc = el.lastChild;
        while (lc && lc.nodeType != 1) {
            if (lc.previousSibling)
                lc = lc.previousSibling;
            else
                break;
        }
        return lc;
    }

    function setEndOfContentEditable(contentEditableElement) {
        while (getLastChildElement(contentEditableElement) &&
        canContainText(getLastChildElement(contentEditableElement))) {
            contentEditableElement = getLastChildElement(contentEditableElement);
        }
        var range = document.createRange();
        range.selectNodeContents(contentEditableElement);
        range.collapse(false);
        var selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
    }

    var _canOverridePaste = undefined;
    var canOverridePaste = function() {
        if (angular.isUndefined(_canOverridePaste)) {
            _canOverridePaste = (function(browser) {
                return (browser.chrome || browser.safari || (browser.msie && browser.version > 10));
            })(bbw.browser);
        }
        return _canOverridePaste;
    };
    var createContextualFragment = (function() {
        var frag = document.createDocumentFragment(),
            elem = document.createElement('div'),
            range = document.createRange && document.createRange();
        frag.appendChild(elem);
        range && range.selectNodeContents(elem);

        return range && range.createContextualFragment ?
            function(html) {
                if (!html) {
                    return document.createDocumentFragment();
                }
                return range.createContextualFragment(html);
            } :
            function(html) {
                if (!html) {
                    return document.createDocumentFragment();
                }
                elem.innerHTML = html;
                var frag = document.createDocumentFragment();
                while (elem.firstChild) {
                    frag.appendChild(elem.firstChild);
                }
                return frag;
            };
    })();

    var editableContTagsRegexp = new RegExp('^(DIV|P|LI|OL|TR|TD|BLOCKQUOTE)$');
    var editableValue = function editableValue(element) {
        if (!element) {
            return '';
        }
        if (element.tagName == 'TEXTAREA') {
            return element.value;
        }
        var el = element.firstChild;
        var result = '';
        while (el) {
            var accumulator;
            switch (el.nodeType) {
                case 1:
                    accumulator = editableValue(el);
                    if (el.tagName && el.tagName.match(editableContTagsRegexp) && accumulator) {
                        if (accumulator.substr(-1) != '\n') {
                            accumulator += '\n';
                        }

                        var prev = el.previousSibling;
                        while (prev && prev.nodeType == 3 && prev.nodeValue.trim() == '') {
                            prev = prev.previousSibling;
                        }
                        if (prev && !(prev.tagName && prev.tagName.match(editableContTagsRegexp))) {
                            accumulator = '\n' + accumulator;
                        }

                    } else if (el.tagName == 'IMG') {
                        accumulator += ('' + el.getAttribute('alt')).trim();
                    } else if (el.tagName == 'BR') {
                        accumulator += '\n';
                    }
                    result += accumulator;
                    break;
                case 3:
                    accumulator = el.data.replace(/^\n|\n$/g, ' ').replace(/[\n\xa0]/g, ' ').replace(/[ ]+/g, ' ');
                    result += accumulator;
                    break;
            }
            el = el.nextSibling;
        }
        return result;
    };


    return {
        restrict: 'A',
        require: '?ngModel',
        template: '<div class="ce-placeholder" style="position: absolute;z-index:-1"></div><div class="ce-editor"></div>',
        link: function(scope, parentElement, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            var element = angular.element(parentElement[0].querySelector('.ce-editor'));

            var placeholderVisible = false;
            var placeholderElement = parentElement[0].querySelector('.ce-placeholder');

            placeholderElement.innerText = attrs.placeholder;

            var submitterName = attrs.bbwContentEditableSubmit;
            if (!submitterName) {
                throw new Error('Submitter is undefined');
            }

            element[0].contentEditable = true;

            var options = {};
            angular.forEach([
                'selectNonEditable',
                'moveCaretToEndOnChange'
            ], function(opt) {
                var option = attrs[opt];
                options[opt] = option && option !== 'false';
            });

            var createTmpTextArea = function() {
                var textArea = document.createElement('textarea');
                textArea.setAttribute('class', 'content-editable-ta-hidden');
                textArea = element[0].parentNode.appendChild(textArea);
                return textArea;
            };

            var removeTmpTextArea = function(textArea) {
                element[0].parentNode.removeChild(textArea);
            };

            var savedSelectionRange;
            var isPasting = false;

            function saveSelectionRange() {
                try {
                    savedSelectionRange = window.getSelection().getRangeAt(0).cloneRange();
                } catch (e) {
                    savedSelectionRange = undefined;
                }
            }

            function restoreSelectionRange(setCursorToEndIfNoRangeSaved) {
                try {
                    var sel = window.getSelection();
                    if (savedSelectionRange) {
                        sel.removeAllRanges();
                        sel.addRange(savedSelectionRange);
                    } else if (setCursorToEndIfNoRangeSaved || sel.getRangeAt(0).commonAncestorContainer != element[0]) {
                        setEndOfContentEditable(element[0]);
                    }
                } catch (e) {
                }
                savedSelectionRange = undefined;
            }

            function isFocused() {
                return document.activeElement === element[0];
            }

            var focus = function(setCursorToEndIfNoRangeSaved, restoreSelectionRangeOnlyIfWasNotFocused) {
                if (!element[0].offsetHeight) {
                    return;
                }
                if (!isFocused()) {
                    element[0].focus();
                    restoreSelectionRange(setCursorToEndIfNoRangeSaved);
                } else if (!restoreSelectionRangeOnlyIfWasNotFocused) {
                    restoreSelectionRange();
                }
            };

            var setupPasteContainer = function() {
                saveSelectionRange();
                window.getSelection().removeAllRanges();
                var textArea = createTmpTextArea();
                textArea.focus();
                return textArea;
            };

            var doInsertNode = function(node) {
                var sel = window.getSelection();
                var range = sel.getRangeAt(0);
                range.deleteContents();
                range.insertNode(node);
                range.setStartAfter(node);
                range.setEndAfter(node);
                sel.removeAllRanges();
                sel.addRange(range);
            };

            var insertNode = function(node, norestore) {
                if (!norestore) {
                    focus();
                }
                doInsertNode(node);
                updateViewValue();
            };

            var insertImage = function(url, insertWithDomWhenUnfocused) {
                if (insertWithDomWhenUnfocused && !isFocused()) {
                    var img = document.createElement('img');
                    img.src = url;
                    img.contentEditable = false;
                    img.setAttribute('unselectable', 'on');
                    element[0].appendChild(img);
                    element[0].appendChild(document.createTextNode(''));
                } else {
                    focus(true, true);
                    document.execCommand('insertImage', false, url);
                    if (bbw.browser.msie) {
                        Array.prototype.forEach.call(element[0].querySelectorAll('img'), function(img) {
                            img.contentEditable = false;
                            img.setAttribute('unselectable', 'on');
                        });
                        var range = window.getSelection().getRangeAt(0);
                        range.collapse(false);
                    } else if (bbw.browser.mozilla) {
                        document.execCommand("enableObjectResizing", false, false);
                    }
                }
                updateViewValue();
            };

            var insertFromPasteContainer = function(textArea) {
                focus();
                doInsertNode(document.createTextNode(textArea.value), true);
                removeTmpTextArea(textArea);
            };

            var cleanHtml = function cleanHtml(cont) {
                var el = cont.firstChild;
                while (el) {
                    var next = el.nextSibling;
                    switch (el.nodeType) {
                        case 1:
                            if (el.tagName == 'DIV' || el.tagName == 'P' || el.tagName == 'SPAN') {
                                el.setAttribute('style', '');
                                el.className = '';
                                el.id = '';
                                cleanHtml(el);
                            } else if (el.tagName == 'IMG' && bbw.configuration.smiley.isSmileyUri(new Uri('' + el.src).path())) {
                                // pass
                            } else if (el.tagName != 'BR') {
                                var text = editableValue(el);
                                var f = createContextualFragment(ngtk.tools.string.escapeHtml(text).replace(/\n/g, '<br>'));
                                el.parentNode.replaceChild(f, el);
                            }
                            break;
                    }
                    el = next;
                }
            };

            element.bind('paste', function() {
                isPasting = true;
                var pasteContainer = canOverridePaste() ? setupPasteContainer() : undefined;
                setTimeout(function(pasteContainer) {
                    isPasting = false;
                    if (pasteContainer) {
                        insertFromPasteContainer(pasteContainer);
                    }
                    cleanHtml(element[0]);
                    $timeout(updateViewValue);
                }.bind(null, pasteContainer), 0);
            });

            var onFocus = attrs.bbwOnFocus;

            var hasFocus = attrs.bbwHasFocus;

            var focusOn = attrs.bbwContentEditableFocusOn;
            if (focusOn) {
                $rootScope.$on(scope.$eval(focusOn), function() {
                    focus();
                });
            }

            element.on('focus', function() {
                if (onFocus) {
                    scope.$evalAsync(onFocus);
                }
                if (hasFocus) {
                    scope.$evalAsync(hasFocus + '=true');
                    updatePlaceholderVisibility();
                }
                $rootScope.$$phase || scope.$apply();
            });

            element.on('blur', function(e) {
                if (hasFocus) {
                    scope.$evalAsync(hasFocus + '=false');
                    $rootScope.$$phase || scope.$apply();
                    updatePlaceholderVisibility();
                }
                if (!isPasting) {
                    saveSelectionRange();
                    e.preventDefault();
                    e.stopPropagation();
                }
                var selection = window.getSelection();
                selection && selection.removeAllRanges();
            });

            function updatePlaceholderVisibility() {
                if (angular.isUndefined(ngModel.$viewValue) || ngModel.$viewValue.trim() === '') {
                    showPlaceholder();
                } else {
                    hidePlaceholder();
                }
            }

            function updateViewValue() {
                var html = element.html().replace(/<div>/gi, '<br>').replace(/<\/div>/gi, '')
                    .replace(/(\s*<br\s*\/?>\s*)+$/i, '');
                ngModel.$setViewValue(html);
                angular.forEach(element[0].querySelectorAll('div'), function(div) {
                    if (div.innerHTML === '') {
                        div.parentElement.removeChild(div);
                    }
                });
                updatePlaceholderVisibility();
            }

            // view -> model
            element.bind('input keyup', function(e) {
                $timeout(updateViewValue);
            });

            function showPlaceholder() {
                placeholderVisible = true;
                placeholderElement.style.display = 'block';
            }

            function hidePlaceholder() {
                placeholderVisible = false;
                placeholderElement.style.display = 'none';
            }

            // model -> view
            var origModelRender = ngModel.$render;
            ngModel.$render = function() {
                var el, elChild, range, sel;
                origModelRender && origModelRender();
                element.html(ngModel.$viewValue || '');
                updatePlaceholderVisibility();
                if (ngModel.$viewValue !== '') {
                    if (options.moveCaretToEndOnChange) {
                        el = element[0];
                        range = document.createRange();
                        sel = window.getSelection();
                        if (el.childNodes.length > 0) {
                            elChild = el.childNodes[el.childNodes.length - 1];
                            range.setStartAfter(elChild);
                        } else {
                            range.setStartAfter(el);
                        }
                        range.collapse(true);
                        sel.removeAllRanges();
                        sel.addRange(range);
                    }
                }
                savedSelectionRange = undefined;
            };

            function getMessageText() {
                updateViewValue();
                var node = element[0].cloneNode(true);
                smileySvc.replaceImagesToTextMarkersInNode(node);
                var div = document.createElement('div');
                div.innerHTML = node.innerHTML.replace(/<div>/gi, '<br>\n').replace(/<\/div>/gi, '');
                var text;
                if (angular.isDefined(div.innerText) && !bbw.browser.mozilla) {
                    text = div.innerText;
                } else {
                    text = ngtk.tools.string.unescapeHtml(div.innerHTML.replace(/<br>\n*/ig, "\n").replace(/<[^>]+>/g, ''));
                }
                return smileySvc.replaceCodesToMarkers(text).trim();
            }

            var ctrl = {
                send: function() {
                    var submitter = scope.$eval(submitterName);
                    if (!angular.isFunction(submitter)) {
                        throw new Error('Not a function: ' + submitterName);
                    }

                    var messageText = getMessageText();
                    return submitter(messageText);
                },

                update: function(fn) {
                    angular.isFunction(fn) && $timeout(function() {
                        updateViewValue(element.html(fn(element.html())));
                        focus();
                        setEndOfContentEditable(element[0]);
                    });
                },

                focus: focus,

                insert: function(node) {
                    insertNode(node);
                },

                insertSmiley: function(name, insertWithDomWhenUnfocused) {
                    var smileyUrl = smileySvc.getUrl(name);
                    if (smileyUrl) {
                        insertImage(smileyUrl, insertWithDomWhenUnfocused);
                    }
                }
            };

            var bindCtrlToScopeKey = attrs.bbwContentEditableBind;
            if (bindCtrlToScopeKey) {
                scope[bindCtrlToScopeKey] = ctrl;
            }

            if (submitterName) {
                var isSubmitModifier = (function() {
                    if (attrs.submitModifier) {
                        return function(e) {
                            return e['' + attrs.submitModifier + 'Key'];
                        };
                    } else {
                        return function(e) {
                            return !['ctrl', 'alt', 'shift', 'meta'].some(function(mod) {
                                return e[mod + 'Key'];
                            });
                        }
                    }
                })();
                element.bind('keydown', function(e) {
                    if (e.keyCode == 13 && isSubmitModifier(e)) {
                        e.stopPropagation();
                        e.preventDefault();
                        if ($rootScope.$$phase) {
                            scope.$evalAsync(ctrl.send);
                        } else {
                            scope.$apply(ctrl.send);
                        }
                    }
                });
            }
        }
    }
}];
